"use client";

import { FC } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { useStyles } from "./styles";
import Logo from "@/components/common/Logo";

interface WatermarkProps {
  hideText?: boolean;
  className?: string;
}

const Watermark: FC<WatermarkProps> = ({
  hideText = false,
  className = "",
}) => {
  const { classes, cx } = useStyles();
  const isLargeScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("lg")
  );

  return (
    <div className={cx(classes.container, className)}>
      <Logo width={isLargeScreen ? "82px" : "48px"} />
      {!hideText && <p className={classes.text}>created on us.idyllic.app</p>}
    </div>
  );
};

export default Watermark;
